<!-- 家长端首页-约课组件 -->
<template>
  <div class="home-reserve-comp schedule-content">
    <div class="schedule-box">
      <div 
        class="schedule-item" 
        v-for="(course,index) in reserveData"
        :key="index">
        <div class="date">{{course.courseStartTime | defineFormatDate}}</div>
        <div class="content">
          <div class="time">{{course.courseStartTime | formatDatetime("hh:mm")}}<span class="t1">上课</span></div>
          <div class="t2 van-ellipsis">
            <span v-if="course.courseArrangePlanType === 0">{{ course.className }}</span> 
            <span v-else>{{ course.curriculumName }}</span>
          </div>
          <div class="t2 van-ellipsis">{{course.studentName}}</div>
          <span class="tag" @click="addReserve(course)">立即预约</span>
        </div>
      </div>
    </div>
    <div class="schedule-more" 
      v-if="reserveData.length>0" 
      @click="$router.push('/reserveList')">更多可约排课
      <van-icon name="arrow" size="var(--fs-lg)" color="var(--g5)"/>
    </div>
    <van-empty
      v-if="reserveData.length==0"
      style="padding-top: 0px;"
      image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
      description="没有可预约课程"
      image-size="100"
    >
    </van-empty>
    <reserveDialog v-model="reserveErrDialogShow" :reserveErrData="reserveErrData" :resCourse="resCourse" />
  </div>
</template>

<script>
import reserveDialog from "@parent/components/reserve-dialog.vue";

export default {
  props: {
    reserveData: {
      type: Array,
      default: []
    },
  },
  components:{
    reserveDialog,
  },
  data () { 
    return {
      resCourse: '',
      reserveErrDialogShow: false,
      reserveErrData: '',
    }
  },
  filters: {
    defineFormatDate(date){
      let day = app.tool.date.formatDatetime(date,'yyyy-MM-dd'),
          today = app.tool.date.formatDatetime(Date.now(),'yyyy-MM-dd');
      if (day == today){
        return '今日/' + app.tool.date.getWeek(date)
      } else {
        return app.tool.date.formatDatetime(date,"MM-dd") + '/' + app.tool.date.getWeek(date)
      }
    }
  },
  methods: {
    addReserve(resCourse) {  //立即预约
      let { 
        curriculumName, 
        priceItemName, 
        courseStartTime, 
        weekDay,
        courseEndTime,
        courseArrangePlanType,
        className } = resCourse;
      let timeStr = app.tool.date.formatDatetime(courseStartTime, "MM月dd日") + ' ';
      timeStr+=`（${app.base.weekDays[weekDay]}） `;
      timeStr+= app.tool.date.formatDatetime(courseStartTime, "hh:mm");
      timeStr+= '~';    
      timeStr+= app.tool.date.formatDatetime(courseEndTime, "hh:mm");
      let classNameStr = courseArrangePlanType === 0 ? className : `${curriculumName}`
      vant.Dialog.confirm({
        title: "约课确认",
        message: `是否确认预约${classNameStr}，${timeStr} ?`,
      })
      .then(()=> {
        this.showLoading();
        this.$api.studentReserve({
          campusId: resCourse.campusId,
          classId: resCourse.classId,
          courseArrangeId: resCourse.courseArrangeId,
          courseReserveId: resCourse.id,
          priceItemId: resCourse.priceItemId,
          studentId: resCourse.studentId,
          curriculumId: resCourse.curriculumId,
        })
        .then(res=> {
          this.$toast.clear();
          if (res.code == 200) {
            vant.Dialog.alert({
              title: "约课成功",
              message: "约课成功，请注意核实上课时间，做好上课准备",
              confirmButtonText: "确定",
            });
            this.$emit("refreshReserve");
          } else if(res.code == 830000018) { //学员剩余课时少于约课所需课时
            this.resCourse = resCourse;
            this.reserveErrDialogShow = true;
            this.reserveErrData = res.data;
            // vant.Dialog.alert({
            //   title: "课时不足",
            //   message: `<div class="reserve_d1">学员的 “${resCourse.curriculumName}” 课时不足，请购买后再预约</div><div class="reserve_d2">剩余可用课时：${res.data.totalRemainAmount}</div><div class="reserve_d2">本次约课所需课时：${res.data.courseAmount}</div>`,
            //   confirmButtonText: "确定",
            // })
          } else{
            this.$toast.fail(res.msg);
          }
        })
      })
      .catch((err)=>{
        console.log(err)
      })

    }
  }
}
</script>

<style lang="scss" scoped>
.home-reserve-comp.schedule-content {
  padding: calc(var(--gap) * 12) calc(var(--gap) * 7) calc(var(--gap) * 12) calc(var(--gap) * 7);
  background-color: var(--white);
  .schedule-box {
    display: flex;
    margin-bottom: calc(var(--gap) * 12);
    .schedule-item {
      padding: 0 5px;
      width: 33.33%;
      .date {
        position: relative;
        padding-left: calc(var(--w) * 7);
        margin-bottom: calc(var(--gap) * 8);
        color: var(--g6);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        font-weight: var(--bold);
        &::before {
          content: "";
          position: absolute;
          top: calc(var(--w) * 3);
          left: 0;
          width: calc(var(--w) * 3);
          height: calc(var(--w) * 10);
          border-radius: calc(var(--w) * 2);
          background-color: var(--c1);
        }
      }
      .content {
        position: relative;
        padding: calc(var(--gap) * 8);
        background-color: var(--g1);
        border-radius: var(--radius-sm);
        .time {
          font-size:var(--fs-ex1);
          line-height:var(--lh-ex1);
          font-weight: var(--bold);
          .t1 {
            font-size:var(--fs-xs);
            line-height:var(--lh-xs);
          }
        }
        .t2 {
          margin-top: calc(var(--gap) * 4);
          font-size:var(--fs-sm);
          line-height:var(--lh-sm);
          color: var(--g6);
        }
        .tag {
          display: inline-block;
          position: absolute;
          bottom: 0;
          right: 0;
          padding: calc(var(--gap) * 2) calc(var(--gap) * 6);
          font-size:var(--fs-xs);
          line-height:var(--lh-xs);
          background-color: var(--c1);
          color: var(--white);
          border-radius: 8px 0px 8px 0px;
        }
      }
    }
  }
  .schedule-more {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    color: var(--g6);
  }
}
</style>
<style lang="scss">
  .van-dialog .reserve_d1,
  .van-dialog .reserve_d2 {
    color: var(--g6);
    font-size:var(--fs-md);
    line-height:var(--lh-md);
  }
  .van-dialog .reserve_d1 {
    margin-bottom: calc(var(--gap) * 30);
  }
</style>